import {useAufgabenHandling} from "../../hooks/aufgaben/useAufgabenHandling";
import Layout from "../../components/Layout";
import {capitalize, Paper, Tab, Tabs} from "@mui/material";
import {Outlet, useParams} from "react-router";
import {aufgabenStyles} from "../../styles/aufgaben/aufgaben.styles";
import {SyntheticEvent} from "react";
import {useUserMandant} from "../../hooks/useUserMandant";
import {permissions} from "../../permissions";

const aufgabeTabs = [
    {
        translationKey: "edit",
        value: "",
        permissions: [
            permissions.aufgaben.edit,
            permissions.aufgaben.own_edit,
            permissions.aufgaben.show,
            permissions.aufgaben.own_show,
        ],
    },
    {
        translationKey: "prompt-versions-tab",
        value: "versions",
        permissions: [permissions.aufgaben.show, permissions.aufgaben.own_show],
    },
    {
        translationKey: "sub-tasks",
        value: "unteraufgaben",
        permissions: [
            permissions.unteraufgaben.list,
            permissions.unteraufgaben.own_list,
            permissions.unteraufgaben.edit,
            permissions.unteraufgaben.own_edit,
            permissions.unteraufgaben.show,
            permissions.unteraufgaben.own_show,
            permissions.unteraufgaben.create,
            permissions.unteraufgaben.own_create,
        ],
    },
    {
        translationKey: "scheduler-tab",
        value: "scheduler",
        permissions: [
            permissions.schedulers.list,
            permissions.schedulers.own_list,
            permissions.schedulers.show,
            permissions.schedulers.own_show,
        ],
    },
    {
        translationKey: "contacts",
        value: "kontakte",
        permissions: [
            permissions.kontakte.list,
            permissions.kontakte.own_list,
            permissions.kontakte.show,
            permissions.kontakte.own_show,
        ],
        availableToMandantAnrufer: true,
    },
];

export default function PageAufgabenTabs() {
    const {translation, currentTab, handleTabChange} = useAufgabenHandling();
    const {checkHasOneOfPermissions, isMandantAnrufer} = useUserMandant();
    const {aufgabeId} = useParams();
    const visibleTabs = isMandantAnrufer
        ? aufgabeTabs.filter(tab => tab.availableToMandantAnrufer)
        : aufgabeTabs;

    return (
        <Layout
            title={isMandantAnrufer ? capitalize(translation("contacts")) : capitalize(translation("task-edit"))}
            back="/aufgaben"
        >
            <Tabs value={currentTab} onChange={(event: SyntheticEvent, newValue) => handleTabChange(
                event,
                newValue,
                aufgabeId
            )}>
                {visibleTabs.map(tab => (
                    <Tab key={tab.value || "edit"}
                         label={capitalize(translation(tab.translationKey))}
                         value={tab.value}
                         disabled={!checkHasOneOfPermissions(tab.permissions)}/>
                ))}
            </Tabs>
            <Paper id={'page-update-aufgabe-paper'}
                   elevation={1}
                   sx={aufgabenStyles.pageUpdateAufgabe.paper}
            >
                <Outlet/>
            </Paper>
        </Layout>
    );
}
